module.exports = __webpack_public_path__ + "static/img/model-icon_dark.db0c2243.png";